import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6e724653 = () => interopDefault(import('../pages/install.vue' /* webpackChunkName: "pages/install" */))
const _3dcce121 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _08ff659b = () => interopDefault(import('../pages/settings.vue' /* webpackChunkName: "pages/settings" */))
const _2314fecc = () => interopDefault(import('../pages/welcome.vue' /* webpackChunkName: "pages/welcome" */))
const _74253e0a = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/install",
    component: _6e724653,
    name: "install"
  }, {
    path: "/login",
    component: _3dcce121,
    name: "login"
  }, {
    path: "/settings",
    component: _08ff659b,
    name: "settings"
  }, {
    path: "/welcome",
    component: _2314fecc,
    name: "welcome"
  }, {
    path: "/",
    component: _74253e0a,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
